import React, { useState } from "react";
import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  floatingButton: {
    cursor: "default",
    transition: "transform 0.3s",
    "&:hover": { transform: "translateY(-5px)", },
  },

  tooltip: {
    fontSize: "0.65em",
  },
}));

const TooltipContainer = ({ i18nMessage }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);



  //  ***************
  //  ** Functions **
  //  ***************
  const handleOpenTooltip = () => {
    setIsTooltipOpen(true);
  };

  const handleCloseTooltip = () => {
    setIsTooltipOpen(false);
  };


  //  ************
  //  ** Return **
  //  ************
  return (
    <Tooltip
      arrow
      disableFocusListener
      disableTouchListener
      placement="top-start"
      PopperProps={{ disablePortal: true }}
      onClose={handleCloseTooltip}
      open={isTooltipOpen}
      title={i18n.t(i18nMessage)}
    >
      <sup onMouseOver={handleOpenTooltip} onMouseOut={handleCloseTooltip}>
        <IconButton color="inherit" className={classes.floatingButton}>
          <HelpOutlineOutlinedIcon className={classes.tooltip} />
        </IconButton>
      </sup>
    </Tooltip>
  );
};

export default TooltipContainer;
